import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";

const ViewRmstock = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});

  useEffect(() => {
        setPermission(FindModuleById(454)); 
        console.log(permission);

   
    axios
      .get(`/production-feeds/view/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.production);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Production Feeds</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/production-feeds">Production Feeds</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Production Feed
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                {permission && permission.list === 1 && (
                  <div className="card-body">
                    <h4 className="card-title">View Production Feed Info</h4>
                    <table className="table table-bordered">
                          <tbody>
                            <tr>
                              <th className="p-3">Date</th>
                              <td className="p-3">{value.date_time}</td>
                            </tr>
                            <tr>
                              <th className="p-3">Palletesation</th>
                              <td className="p-3">
                                {value.palletesation_raw_material && value.palletesation_raw_material
                                  ? value.palletesation_raw_material.barcode
                                  : ""}
                              </td>
                            </tr>
                          </tbody>
                        </table>

                  </div>
                )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ViewRmstock;
